import _ from "underscore"
import TemplateView from "../../TemplateView"
import {connect, unsafe_selectWithState} from "../../redux/utils"
import {getShownColumnsWithOrder, getSummaryRow} from './selectors'
import {getCustomFieldsFilters, getIntersectedCPSelection, getRecentlyCreatedTaskIds, getTaskCustomFieldsMap, getTaskNameFilter, getTaskStatusFilter, getViewMode, isShowOnlyManageableTasks} from '../common/selectors'
import {PRIORITY_FIELD_NAME, TaskManagementViewMode, TaskTableConfigurableColumns} from '../constants'
import {isBTYEnabled, isESTEnabled, isTWSEnabled} from '../../features/selectors'
import {isSummaryRowLoaded } from '../tasksTable/selectors'
import UserTime from '../../user_time'
import { bindActionCreators } from "redux"
import { updateSummaryRow } from "./actions"
import { isTasksLoaded } from "../taskSelection/selectors"
import ClassicBridge from '../../next/ClassicBridge'
import { importTasksSuccessEvent } from '../syncCallbacks'
import { getWorkflowStatuses } from "../../entities/selectors"
import { PDF_OPEN_TYPE_COLOR_MAP_BY_COLOR_NAME } from "../../user/viewtt/pdf/constants"
import { WorkflowStatusType } from "../../workflowStatus/constants"
import { DateFormat } from "../../date_format"
import WorkFlowStatusIcon from "../../workflowStatus/WorkflowStatusIcon"
import { selectFakeStatusIdByTaskComplete, selectStatusById } from "../../workflowStatus/selectors"

const dateFormat = new DateFormat(window.SystemSettings.dateFormat)

const TOTAL_TASKS = 'TOTAL_TASKS'
const STATUS = 'STATUS'
const DEBOUNCE_UPDATE_DELAY = 500

const STATIC_COLUMNS = new Set([TOTAL_TASKS, STATUS])
const EMPTY_PLACEHOLDER = '--'

const TASK_UPDATE_EVENTS = [
    "taskManagement_tasksMovedTo",
    "taskManagement_taskUpdated",
    "taskManagement_removeTasks",
    "editTaskPanel_updateTask",
    "taskManagement_task_startEditing",
    "taskManagement_tasksStatusChanged",
    "taskManagement_projectCustomerStatusChanged",
    importTasksSuccessEvent
]

const COLUMNS_CLASSNAME_MAP = {
    [TOTAL_TASKS]: "totalTasks",
    [STATUS]: "statusFiller",
    [TaskTableConfigurableColumns.ESTIMATE]: "totalEstimate",
    [TaskTableConfigurableColumns.DEADLINE]:"deadlineFiller",
    [TaskTableConfigurableColumns.CREATION_DATE]: "creationDateFiller",
    [TaskTableConfigurableColumns.LAST_TRACKING_DATE]: "lastTrackingDateFiller",
    [TaskTableConfigurableColumns.SPENT_TIME]: "totalSpentTime",
    [TaskTableConfigurableColumns.TYPE_OF_WORK]: "typeOfWorkFiller",
    [TaskTableConfigurableColumns.VARIANCE_MAN_HOURS]: "totalVarianceManHours",
    [TaskTableConfigurableColumns.VARIANCE_PERCENTS]: "totalVariancePercent",
    [TaskTableConfigurableColumns.VARIANCE_PROGRESS_BAR]: "varianceProgressBarFiller",
}

class SummaryRow extends TemplateView {
    constructor({
        update,
    }) {
        super()

        this.state = {
            columnsOrder: [],
            customFields: {},
            isBTYEnabled: null,
            isTWSEnabled: null,
            isLoaded: false,
            tasksLoaded: false,
            isNeedToReloadTableTasks: false,
            recentlyCreatedTaskIds: {},
            isShown: false,
            viewMode: TaskManagementViewMode.TABLE,
            customFieldsFilters: {},
            taskStatusFilter: {
                allSelected: false,
                statusIds: [],
                statusTypes: [],
            },
            summaryRow: {},
            workflowStatuses: {},
        }
        this.actions = {
            update
        }

        this.onStatePropertyDeeplyChanged('customFields', (customFields) => {
            this._clearCustomFieldsColumns()
            this._renderCustomFieldsColumns(customFields)
        })

        this.onStatePropertyChanged('columnsOrder', (columnsOrder) => {
            for (let column of Object.keys(COLUMNS_CLASSNAME_MAP)) {
                if (this._isStaticField(column)) continue

                const columnEl = this._findByKey(column)
                columnEl.hide()
            }

            for (let i = 0; i < columnsOrder.length; ++i) {
                const column = columnsOrder[i]
                const columnEl = this._findByKey(column)

                columnEl.show().css('display', 'flex')
                columnEl.css('order', i.toString())
            }

            if (columnsOrder.includes(PRIORITY_FIELD_NAME)) {
                this._findByKey(TOTAL_TASKS).addClass('withPriority')
            }
        })

        this.onStatePropertyChanged('isBTYEnabled', (isBTYEnabled) => {
            this._toggleColumn(TaskTableConfigurableColumns.TYPE_OF_WORK, isBTYEnabled && this.state.columnsOrder.includes(TaskTableConfigurableColumns.TYPE_OF_WORK))
        })

        this.onStatePropertyChanged('isESTEnabled', (isESTEnabled) => {
            const columnsOrder = this.state.columnsOrder
            this._toggleColumn(TaskTableConfigurableColumns.ESTIMATE, isESTEnabled && columnsOrder.includes(TaskTableConfigurableColumns.ESTIMATE))
            this._toggleColumn(TaskTableConfigurableColumns.VARIANCE_MAN_HOURS, isESTEnabled && columnsOrder.includes(TaskTableConfigurableColumns.VARIANCE_MAN_HOURS))
            this._toggleColumn(TaskTableConfigurableColumns.VARIANCE_PERCENTS, isESTEnabled && columnsOrder.includes(TaskTableConfigurableColumns.VARIANCE_PERCENTS))
            this._toggleColumn(TaskTableConfigurableColumns.VARIANCE_PROGRESS_BAR, isESTEnabled && columnsOrder.includes(TaskTableConfigurableColumns.VARIANCE_PROGRESS_BAR))
        })

        this.onStatePropertyChanged('isTWSEnabled', (isTWSEnabled) => {
            if (isTWSEnabled) {
                this._renderColumnChartValue(this._workflowStatusesBins(), COLUMNS_CLASSNAME_MAP[STATUS])
            } else {
                this._renderWorkstatuses()
            }
        })

        this.onStatePropertyChanged('isLoaded', () => {
            if (this.state.isLoaded) {
                this._setColumnTextValue(TOTAL_TASKS, this._totalTasks())
                this._setColumnTextValue(TaskTableConfigurableColumns.ESTIMATE, this._totalEstimate())
                this._setColumnTextValue(TaskTableConfigurableColumns.SPENT_TIME, this._totalSpentTime())
                this._setColumnTextValue(TaskTableConfigurableColumns.VARIANCE_MAN_HOURS, this._totalVarianceManHours())
                this._setColumnTextValue(TaskTableConfigurableColumns.VARIANCE_PERCENTS, this._totalVariancePercent())
                this._setColumnTextValue(TaskTableConfigurableColumns.DEADLINE, this._closestDeadline(), messageResource.getMessage('common.nearest'))
                this._setColumnTextValue(TaskTableConfigurableColumns.LAST_TRACKING_DATE, this._lastTrackingDate(), messageResource.getMessage('common.latest'))
                this._setColumnTextValue(TaskTableConfigurableColumns.CREATION_DATE, this._lastCreationDate(), messageResource.getMessage('common.latest'))

                if (this.state.isTWSEnabled) {
                    this._setColumnChartValue(STATUS, this._workflowStatusesBins())
                } else {
                    this._renderWorkstatuses()
                }
            } else {
                this._renderLoadingState()
            }
            this._updateColumnsStyle()
        })

        this.onStatePropertyChanged('workflowstatuses', () => {
            this._setColumnChartValue(STATUS, this._workflowStatusesBins())
        })

        this._debounceUpdateIfVisible = _.debounce(() => this._updateIfVisible(), DEBOUNCE_UPDATE_DELAY)

        this._subscribeToUpdateEvents()
    }

    _subscribeToUpdateEvents() {
        TASK_UPDATE_EVENTS.forEach((event) => {
            $(document).on(event, this._debounceUpdateIfVisible)
        })

        this.onAnyStatePropertyDeeplyChanged([
            'recentlyCreatedTaskIds',
            'viewMode',
            'taskNameFilter',
            'cpSelection',
            'showOnlyManagableTasks',
            'taskStatusFilter',
            'customFieldsFilters',
            'isShown'
        ], this._debounceUpdateIfVisible)
    }

    _updateIfVisible() {
        if (this._isVisible()) {
            this.actions.update()
        }
    }

    _isVisible() {
        return this.state.isShown && this.state.viewMode === TaskManagementViewMode.TABLE
    }

    _clearCustomFieldsColumns() {
        Object.keys(COLUMNS_CLASSNAME_MAP)
              .filter(column => ClassicBridge.isCustomField(column))
              .forEach(cf => this._clearColumn(cf))
    }

    _clearColumn(column) {
        const columnEl = this._findByKey(column)
        columnEl.remove()
        COLUMNS_CLASSNAME_MAP[column] = null
    }

    _toggleColumn(column, value) {
        const columnEl = this._findByKey(column)
        columnEl.toggle(value)
    }

    _setColumnTextValue(column, value, label) {
        const textEl = this._findByKey(column).find(".headerCellWrapper > span")
        if (label) {
            textEl.replaceWith($(`<span class="valueWithLabel">
                <span class="label">${label}</span>
                <span class="value">${value}</span>
            </span>`))
        } else {
            textEl.text(value)
        }
    }

    _setColumnChartValue(column, value) {
        const columnEl = this._findByKey(column).find(".headerCellWrapper")

        if (value.length !== 0) {
            const chartEl = columnEl.find(".atNextMount.histogram")

            if (chartEl.length === 0) {
                this._renderColumnChartValue(this._workflowStatusesBins(), COLUMNS_CLASSNAME_MAP[column])
            } else {
                chartEl[0].nextComponent.setProps({
                    bins: value
                })
            }
        } else {
            columnEl.html($(`<span>${EMPTY_PLACEHOLDER}</span>`))
        }
    }

    _updateColumnsStyle() {
        Object.keys(COLUMNS_CLASSNAME_MAP)
              .forEach(column => {
                  const columnValue = this._getColumnValueByKey(column)
                  const columnEl = this._findByKey(column)
                  if (column !== TOTAL_TASKS) { this._updateEmptyStyle(columnValue, columnEl) }
                  this._updateNegativeStyle(columnValue, columnEl)
              })
    }

    _updateEmptyStyle(columnValue, columnEl) {
        const isNotEmpty = _.isNumber(columnValue) && this.state.isLoaded
        columnEl.toggleClass('nonEmptyFiller', isNotEmpty)
    }

    _updateNegativeStyle(columnValue, columnEl) {
        const isNegative = (_.isNumber(columnValue) && columnValue < 0) && this.state.isLoaded
        columnEl.toggleClass('negativeFiller', isNegative)
    }

    _renderColumnValue(valueElement, className) {
        const valueCell = $(`<td class='${className}'>` +
          `  <div class='headerCellWrapper'></div>` +
          "</td>")

        valueCell
            .find(':last')
            .append(valueElement)

        valueCell.appendTo(this.$el)
    }

    _renderColumnTextValue(value, className) {
        const valueElement = $(`<span>${value}</span>`)
        this._renderColumnValue(valueElement, className)
    }

    _renderColumnChartValue(value, className) {
        const chartEl = this._findByKey(STATUS).find(".headerCellWrapper")

        const valueWrapper = $(`<div class='atNextMount histogram'></div>`)[0]
        valueWrapper.nextComponent = ClassicBridge.integrateHistogram(valueWrapper, {
            bins: value,
            maxVisibleBinsCount: 6,
            tooltipId: className
        })
        chartEl.html(valueWrapper)
    }

    _renderWorkstatuses() {
        const columnEl = this._findByKey(STATUS).find(".headerCellWrapper")
        if (columnEl.length === 0 || !this.state.summaryRow.active) {
            columnEl.html($(`<span>${EMPTY_PLACEHOLDER}</span>`))
        } else {
            const activeStatus = unsafe_selectWithState(state => selectStatusById(state, selectFakeStatusIdByTaskComplete(false)))
            const inactiveStatus = unsafe_selectWithState(state => selectStatusById(state, selectFakeStatusIdByTaskComplete(true)))

            const valueWrapper = $(`<div class="workflowStatusesContainer">
                <div class="activeStatusIcon" /><span class="workflowStatusLabel">${this.state.summaryRow.active.true || EMPTY_PLACEHOLDER}</span>
                <div class="inactiveStatusIcon" /><span class="workflowStatusLabel">${this.state.summaryRow.active.false || EMPTY_PLACEHOLDER}</span>
            </div>`)

            new WorkFlowStatusIcon(null, activeStatus).init(valueWrapper.find('.activeStatusIcon'))
            new WorkFlowStatusIcon(null, inactiveStatus).init(valueWrapper.find('.inactiveStatusIcon'))

            columnEl.html(valueWrapper)
        }

    }

    _renderCustomFieldsColumns(customFields) {
        Object.values(customFields)
            .filter(customField => !customField.builtin)
            .forEach((customField) => {
                const column = customField.fieldName
                const className = `customFieldFiller ${column}`

                COLUMNS_CLASSNAME_MAP[customField.fieldName] = column

                this._renderColumnTextValue(EMPTY_PLACEHOLDER, className)
            })
    }

    _renderInitialColumns() {
        Object.values(COLUMNS_CLASSNAME_MAP)
              .forEach(className => {
                  this._renderColumnTextValue(EMPTY_PLACEHOLDER, className)
              })
    }

    _renderLoadingState() {
        Object.keys(COLUMNS_CLASSNAME_MAP)
              .forEach(column => {
                  this._setColumnTextValue(column, column === TOTAL_TASKS ? this._totalTasksEmpty() : EMPTY_PLACEHOLDER)
                  if (column === TOTAL_TASKS) { this._findByKey(TOTAL_TASKS).toggleClass('nonEmptyFiller', true) }
              })
    }

    _totalTasks() {
        return messageResource.getMessage('task.list.header.totalTasks', [this.state.summaryRow.taskCount]);
    }

    _totalTasksEmpty() {
        return messageResource.getMessage('task.list.header.totalTasksEmpty');
    }

    _totalEstimate() {
        const estimate = this.state.summaryRow.estimate
        return _.isNumber(estimate) ? UserTime.formatTimeWithDigitSeparator(estimate) : EMPTY_PLACEHOLDER
    }

    _totalSpentTime() {
        return UserTime.formatTimeWithDigitSeparator(this.state.summaryRow.spentTime)
    }

    _totalVarianceManHours() {
        const variance = this.state.summaryRow.variance
        return (variance && _.isNumber(variance.duration)) ? UserTime.formatTimeWithDigitSeparator(variance.duration) : EMPTY_PLACEHOLDER
    }

    _workflowStatusesBins() {
        if (!this.state.summaryRow.workflowstatuses || !this.state.workflowStatuses)
            return []

        const bins = Object
            .entries(this.state.summaryRow.workflowstatuses)
            .map(([key, value]) => {
                const workstatus = this.state.workflowStatuses[key]

                return {
                    name: workstatus.name,
                    value: value,
                    properties: [{
                        name: 'count',
                        value,
                        color: PDF_OPEN_TYPE_COLOR_MAP_BY_COLOR_NAME[workstatus.colorId] + (workstatus.type === WorkflowStatusType.OPEN ? '88' : '')
                    }]
                }
            })

        bins.sort((a, b) => b.value - a.value)
        return bins
    }


    _totalVariancePercent() {
        const variance = this.state.summaryRow.variance
        return (variance && _.isNumber(variance.percentage)) ? ((Math.round(variance.percentage * 100) / 100).toFixed(1) + '%') : EMPTY_PLACEHOLDER
    }

    _closestDeadline() {
        return this._renderDate(this.state.summaryRow.closestDeadline)
    }

    _lastTrackingDate() {
        return this._renderDate(this.state.summaryRow.lastTrackingDate)
    }

    _lastCreationDate() {
        return this._renderDate(this.state.summaryRow.lastCreationDate)
    }

    _renderDate(date) {
        if (!date) return EMPTY_PLACEHOLDER

        const dateFormatted = new Date(date)
        return dateFormat.formatDate(dateFormatted)
    }

    _findByKey(key) {
        return this.find(`.${COLUMNS_CLASSNAME_MAP[key]}`)
    }

    _getColumnValueByKey(key) {
        return {
            [TOTAL_TASKS]: this.state.summaryRow.taskCount,
            [TaskTableConfigurableColumns.ESTIMATE]: this.state.summaryRow.estimate,
            [TaskTableConfigurableColumns.SPENT_TIME]: this.state.summaryRow.spentTime,
            [TaskTableConfigurableColumns.VARIANCE_MAN_HOURS]: this.state.summaryRow.variance && this.state.summaryRow.variance.duration,
            [TaskTableConfigurableColumns.VARIANCE_PERCENTS]: this.state.summaryRow.variance && this.state.summaryRow.variance.percentage,
            [TaskTableConfigurableColumns.DEADLINE]: this.state.summaryRow.closestDeadline,
            [TaskTableConfigurableColumns.LAST_TRACKING_DATE]: this.state.summaryRow.lastTrackingDate,
            [TaskTableConfigurableColumns.CREATION_DATE]: this.state.summaryRow.lastCreationDate,
        }[key]
    }

    _isStaticField(column) {
        return STATIC_COLUMNS.has(column)
    }


    templateHtml() {
        return "<tr class='summary'></tr>"
    }

    toggle(value) {
        this.setState({ isShown: value })
        super.toggle(value)
    }

    afterRender() {
        this.$el.hide()

        this._renderInitialColumns()
        this._renderLoadingState()
        this.renderInitialState()
    }
}

export default connect(
    (state) => ({
        summaryRow: getSummaryRow(state),
        columnsOrder: getShownColumnsWithOrder(state),
        customFields: getTaskCustomFieldsMap(state),
        isBTYEnabled: isBTYEnabled(state),
        isESTEnabled: isESTEnabled(state),
        isTWSEnabled: isTWSEnabled(state),
        isLoaded: isSummaryRowLoaded(state),
        tasksLoaded: isTasksLoaded(state),
        recentlyCreatedTaskIds: getRecentlyCreatedTaskIds(state),
        viewMode: getViewMode(state),
        cpSelection: getIntersectedCPSelection(state),
        taskNameFilter: getTaskNameFilter(state),
        taskStatusFilter: getTaskStatusFilter(state),
        customFieldsFilters: getCustomFieldsFilters(state),
        showOnlyManagableTasks: isShowOnlyManageableTasks(state),
        workflowStatuses: getWorkflowStatuses(state)
    }),
    (dispatch) => ({
        update: bindActionCreators(updateSummaryRow, dispatch)
    })
)(SummaryRow)



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/SummaryRow.js